import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ShippingMethod, ShippingMethodClient } from "src/app/web-api-client";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Subject } from "rxjs";

@Component({
  selector: 'app-shipping-method-edit',
  templateUrl: './shipping-method-edit.component.html',
  styleUrls: ['./shipping-method-edit.component.scss']
})
export class ShippingMethodEditComponent implements OnInit {

  public isLoaded = false;
  public editObject: ShippingMethod;
  public onClose = new Subject<boolean>();

  Form: FormGroup;

  constructor(private fb: FormBuilder,public activeModal: NgbActiveModal, public client: ShippingMethodClient) { }

  ngOnInit(): void {

    this.initializeForm();
    this.isLoaded = true;
  }

  initializeForm() {
    this.Form = this.fb.group({
      name: [this.editObject.name, Validators.required],
      price: [this.editObject.price, Validators.required],
      isActive: [this.editObject.isActive, Validators.required],
    });
  }

  onSubmit() {
    if (this.Form.valid) {

      this.editObject.name = this.Form.value.name;
      this.editObject.price = this.Form.value.price;
      this.editObject.isActive = this.Form.value.isActive;

      this.client.update(this.editObject).subscribe((result) => {
        this.onClose.next(true);
        this.activeModal.close();
      });
    }
  }

  closeModal() {
    this.onClose.next(true);
    this.activeModal.close();
  }

}

